import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-refresh\">\r\n  <path id=\"icon-refresh_路径_2018\" data-name=\"路径 2018\" d=\"M17.65,6.35A8,8,0,1,0,19.73,14H17.65A6,6,0,1,1,12,6a5.915,5.915,0,0,1,4.22,1.78L13,11h7V4Z\" />\r\n  <path id=\"icon-refresh_路径_2019\" data-name=\"路径 2019\" d=\"M0,0H24V24H0Z\" fill=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol